/*
 * 仅用于替换 @weike/operation-report，承接原来打到 collector 的运营埋点。
 * 新的埋点请直接调用玄武 TorDataService / emitAction，不要再使用本文件。
 */
import * as React from 'react'
import { findDOMNode } from 'react-dom'
import 'intersection-observer'
import { getJsonFromUrl } from '../utils/tools'
import { reportOperationLogs } from './tortoiseReport'

const hijack = 'hijack'

export let initSpm = ''

/** @deprecated 仅承接原 collector 运营埋点。新埋点请直接调用玄武 TorDataService.emitAction */
export function setUbtInit(project: string, page: string) {
  initSpm = `wk.${project}.@replaceSceen-${page}`
}

/** @deprecated 仅承接原 collector 运营埋点。新埋点请直接调用玄武 TorDataService.emitAction */
export function getUbt() {
  return initSpm
}

function isFromOutSide() {
  return window.location.href.indexOf('outside_site') > -1
}

/** @deprecated 仅承接原 collector 运营埋点。新埋点请直接调用玄武 TorDataService.emitAction */
export function reAssemblyUbt(element: string, scene?: string) {
  if (isFromOutSide()) {
    return `${initSpm.replace('.@replaceSceen', `.${hijack}`)}.${element}`
  }
  if (scene || window.location.href.indexOf('scene') > -1) {
    const nextScene = scene || getJsonFromUrl().scene
    return `${initSpm.replace('.@replaceSceen', `.${nextScene}`)}.${element}`
  }
  return `${initSpm.replace('.@replaceSceen', '')}.${element}`
}

/** @deprecated 仅承接原 collector 运营埋点。新埋点请直接调用玄武 TorDataService.emitAction */
export function reportViewEvent(element: string, evtParams: { [key: string]: any } = {}, scene?: string) {
  let ubt = reAssemblyUbt(element, scene)
  if (isFromOutSide()) {
    ubt = reAssemblyUbt(element, hijack)
  }
  try {
    reportOperationLogs([{ ubt, evt: 'view', evt_params: evtParams }])
  } catch (err) {
    console.log(err)
  }
}

/** @deprecated 仅承接原 collector 运营埋点。新埋点请直接调用玄武 TorDataService.emitAction */
export function reportClickEvent(element: string, evtParams: { [key: string]: any } = {}, scene?: string) {
  let ubt = reAssemblyUbt(element, scene)
  if (isFromOutSide()) {
    ubt = reAssemblyUbt(element, hijack)
  }
  try {
    reportOperationLogs([{ ubt, evt: 'click', evt_params: evtParams }])
  } catch (err) {
    console.log(err)
  }
}

interface ExposureItem {
  ubt: string
  params?: { [key: string]: any }
}

const exposureList: ExposureItem[] = []

setInterval(() => {
  if (exposureList.length === 0) {
    return
  }
  const batch = exposureList.splice(0, exposureList.length)
  reportOperationLogs(
    batch.map(item => ({
      ubt: item.ubt,
      evt: 'impress',
      evt_params: item.params || {}
    }))
  )
}, 1000)

interface ViewingMonitorProps {
  children: React.ReactNode
  params?: { [key: string]: any }
  ubt: string
  timeDelay?: number
}

/** @deprecated 仅承接原 collector 曝光上报。新埋点请直接调用玄武 TorDataService.emitAction */
class ViewingMonitor extends React.Component<ViewingMonitorProps> {
  private element: Element | null = null
  private timer: number | null = null
  private hasExplosure = false
  private observer = new IntersectionObserver(
    entries => {
      this.startVisible(entries[0])
    },
    { threshold: [0.5, 1] }
  )

  public componentDidMount() {
    const node = findDOMNode(this)
    if (node && node.nodeType === Node.ELEMENT_NODE) {
      this.element = node as Element
      this.observer.observe(this.element)
    }
  }

  public componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer)
    }
    if (this.element) {
      this.observer.unobserve(this.element)
    }
    this.observer.disconnect()
  }

  public render() {
    return this.props.children as React.ReactElement
  }

  private startVisible(entrie: IntersectionObserverEntry) {
    if (!this.element) {
      return
    }
    if (this.timer) {
      window.clearTimeout(this.timer)
    }
    const element = this.element
    this.timer = window.setTimeout(() => {
      if (entrie.isIntersecting && entrie.intersectionRatio > 0.5 && !this.hasExplosure) {
        this.hasExplosure = true
        this.observer.unobserve(element)
        exposureList.push({
          ubt: this.props.ubt,
          params: this.props.params
        })
      }
    }, this.props.timeDelay ? this.props.timeDelay : 2000)
  }
}

export { ViewingMonitor }



// WEBPACK FOOTER //
// ./src/services/operationReport.ts